import React from "react";
import { RiRefreshLine, RiCheckLine } from "react-icons/ri";

const MonthPicker = ({
  setTotal,
  currentYear,
  currentMonth,
  loadStatistics,
  setCurrentYear,
  setCurrentMonth,
  setLocalSetStats,
}: any) => {
  const YEARS = Array.from({ length: 4 }).map(
    (_, i) => new Date().getFullYear() - 3 + i
  );

  const MONTHS = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December",
  ];

  const monthAbbr = (m: string) => m.slice(0, 3);

  const resetToToday = () => {
    const now = new Date();
    const y = now.getFullYear();
    const m = now.getMonth() + 1;
    setLocalSetStats(null);
    setTotal(0);
    setCurrentYear(y);
    setCurrentMonth(m);
    loadStatistics({ year: y, month: m });
  };

  return (
    <div className="p-5">
      {/* Header */}
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h3 className="text-sm font-semibold text-gray-900">Filter by period</h3>
          <p className="mt-0.5 text-xs text-gray-500">
            Pick a year and month to load statistics
          </p>
        </div>
        <button
          type="button"
          onClick={resetToToday}
          className="inline-flex items-center gap-2 self-start rounded-lg border border-gray-200 bg-white px-3 py-1.5 text-xs font-medium text-gray-700 shadow-sm transition hover:border-gray-300 hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand sm:self-auto"
        >
          <RiRefreshLine className="h-3.5 w-3.5" />
          Reset to today
        </button>
      </div>

      <div className="mt-5 grid grid-cols-1 gap-5 lg:grid-cols-12">
        {/* Year — segmented control */}
        <div className="lg:col-span-4">
          <p className="mb-2 text-[11px] font-semibold uppercase tracking-wide text-gray-600">
            Year
          </p>
          <div className="flex w-full rounded-xl border border-gray-200 bg-gray-50 p-1">
            {YEARS.map((year) => {
              const selected = currentYear === year;
              return (
                <button
                  key={year}
                  type="button"
                  aria-pressed={selected}
                  onClick={() => {
                    setLocalSetStats(null);
                    setTotal(0);
                    setCurrentYear(year);
                    loadStatistics({ year, month: currentMonth });
                  }}
                  className={[
                    "flex-1 rounded-lg px-3 py-1.5 text-xs font-semibold transition",
                    "focus:outline-none focus-visible:ring-2 focus-visible:ring-brand",
                    selected
                      ? "bg-gray-900 text-white shadow-sm"
                      : "text-gray-600 hover:bg-white hover:text-gray-900",
                  ].join(" ")}
                >
                  {year}
                </button>
              );
            })}
          </div>
        </div>

        {/* Month — clean grid */}
        <div className="lg:col-span-8">
          <p className="mb-2 text-[11px] font-semibold uppercase tracking-wide text-gray-600">
            Month
          </p>
          <div className="grid grid-cols-4 gap-2 sm:grid-cols-6">
            {MONTHS.map((month, index) => {
              const selected = currentMonth - 1 === index;
              return (
                <button
                  key={month}
                  type="button"
                  aria-pressed={selected}
                  title={month}
                  onClick={() => {
                    setLocalSetStats(null);
                    setTotal(0);
                    setCurrentMonth(index + 1);
                    loadStatistics({ month: index + 1, year: currentYear });
                  }}
                  className={[
                    "inline-flex items-center justify-center gap-1 rounded-lg px-3 py-2 text-xs font-semibold transition",
                    "focus:outline-none focus-visible:ring-2 focus-visible:ring-brand",
                    selected
                      ? "bg-gray-900 text-white shadow-sm"
                      : "border border-gray-200 bg-white text-gray-700 hover:border-gray-300 hover:bg-gray-50",
                  ].join(" ")}
                >
                  {selected && <RiCheckLine className="h-3.5 w-3.5" />}
                  {monthAbbr(month)}
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MonthPicker;
